import { ProductInfoBoxOrder as CoreProductInfoBoxOrder } from 'core/components'
import { T, __ } from 'stylewhere/i18n'

export class ProductInfoBoxOrder extends CoreProductInfoBoxOrder {
  getAttributes = () => {
    return [
      { label: __(T.fields.entity), path: 'productionOrder.attributes.sender' },
      { label: __(T.fields.year), path: 'productionOrder.attributes.year' },
      { label: __(T.fields.number), path: 'productionOrder.attributes.number' },
      { label: __(T.fields.row), path: 'productionOrder.attributes.row' },
      { label: __(T.fields.season), path: 'productionOrder.attributes.season' }
    ]
  }
}
